import React from "react";

const Footer = () => {
  return (
    <footer className="relative bg-[#FAF5EC] border-t border-[#E5DDD0] py-20" data-testid="footer">
      <div className="max-w-screen-2xl mx-auto px-6 md:px-12 lg:px-20">
        <div className="flex flex-col items-center text-center gap-6 mb-16">
          <span className="font-serif text-3xl tracking-[0.35em] text-[#1A1612]">ELENUIT</span>
          <div className="sep-line max-w-[180px]">
            <span className="diamond" />
          </div>
          <p className="font-serif italic text-lg text-[#6E665A] tracking-wide max-w-md">
            Sub lună, fiecare clipă strălucește.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 pt-10 border-t border-[#E5DDD0]">
          <div className="text-center md:text-left">
            <p className="text-[10px] uppercase tracking-[0.3em] text-[#B8954C] mb-4">
              Date Companie
            </p>
            <p className="text-sm text-[#1A1612] font-medium" data-testid="footer-company">
              REIA-AUGUSTIN S.R.L.
            </p>
          </div>
          <div className="text-center md:text-right">
            <p className="text-[10px] uppercase tracking-[0.3em] text-[#B8954C] mb-4">
              Contact
            </p>
            <p className="text-sm text-[#1A1612] leading-relaxed" data-testid="footer-address">
              Str. Cuza Vodă, Nr. 81, Ap. Birou 5,<br />Târgu Frumos, România
            </p>
          </div>
        </div>

        <div className="flex flex-col md:flex-row items-center justify-between gap-4 pt-10 mt-10 border-t border-[#E5DDD0]">
          <p className="text-[10px] uppercase tracking-[0.25em] text-[#A29A8B]">
            © {new Date().getFullYear()} ELENUIT · Toate drepturile rezervate.
          </p>
          <div className="flex gap-6">
            <a href="#story" className="text-[10px] uppercase tracking-[0.25em] text-[#A29A8B] hover:text-[#B8954C] transition">Poveste</a>
            <a href="#products" className="text-[10px] uppercase tracking-[0.25em] text-[#A29A8B] hover:text-[#B8954C] transition">Shop</a>
            <a href="#contact" className="text-[10px] uppercase tracking-[0.25em] text-[#A29A8B] hover:text-[#B8954C] transition">Contact</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
